import { PartnerProgramState } from '@layout/partner-program/store/states/partner-program.state';

export const partnerProgramState = [PartnerProgramState];
